export default __webpack_public_path__ + "static/media/ic_avatar.bdc5200f.svg";